import { SignIn } from '@clerk/react';

// HG brand applied to Clerk's prebuilt <SignIn /> via the OFFICIAL appearance API
// only (variables + elements) — never Clerk's internal class names, which change
// between versions. https://clerk.com/docs/customization/overview
const hgAppearance = {
  variables: {
    colorPrimary: '#48B64C',      // HG green-cyan (the "Continue" button)
    colorBackground: '#FFFFFF',   // white card (matches the app's light theme)
    colorText: '#1A1A1A',         // dark text
    colorInputBackground: '#FFFFFF',
    colorInputText: '#1A1A1A',
    borderRadius: '4px',          // HG brand: 4px max
    // Force a legible sans-serif INSIDE Clerk. The app's display/monospace font
    // must not bleed into the Clerk UI (it was making the header pixelated).
    fontFamily: 'system-ui, -apple-system, sans-serif',
  },
  elements: {
    // Drop the default shadow "ghost" edge; one clean border in the HG palette.
    card: { boxShadow: 'none', border: '1px solid #E2E2DC', backgroundColor: '#FFFFFF' },
    // Belt-and-suspenders: header was inheriting the HG display font via a parent.
    headerTitle: { fontFamily: 'system-ui, -apple-system, sans-serif' },
    headerSubtitle: { fontFamily: 'system-ui, -apple-system, sans-serif' },
    // Keep the footer (it carries the "Sign up" link users need) but de-chrome it.
    footer: { backgroundColor: 'transparent', borderTop: 'none' },
    // "Sign up" link — keep visible, brand it HG green.
    footerActionLink: { color: '#48B64C', fontFamily: 'system-ui, -apple-system, sans-serif' },
    // Hide bottom page links (e.g. dev/secured page links) — does NOT hide Sign up.
    // NOTE: the "Secured by Clerk" badge + dev-mode strip are Clerk-plan/instance
    // controlled and go away on a production instance; accepted for now.
    footerPagesLink: { display: 'none' },
  },
};

export default function Login() {
  return (
    <div
      data-testid="login-page"
      className="min-h-screen bg-hg-bg flex flex-col items-center justify-center p-4"
    >
      <div className="text-center space-y-2 mb-8">
        <div className="text-[10px] font-sans text-hg-green uppercase tracking-[0.3em]">
          Henry-Griffitts
        </div>
        <h1 className="font-display text-2xl lg:text-3xl text-hg-text tracking-wider">
          HG HUB
        </h1>
        <p className="text-sm text-hg-text-dim font-sans">
          Private workspace. Sign in to access the studios.
        </p>
      </div>

      {/* Wrapper gives Clerk a predictable parent context and resets the inherited
          app display font, so the global font can't clobber the Clerk UI. */}
      <div
        className="hg-clerk-signin"
        style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}
      >
        <SignIn appearance={hgAppearance} />
      </div>

      <div className="text-center mt-8">
        <div className="text-[10px] font-sans text-hg-text-dim uppercase tracking-[0.2em]">
          Equipment Affects Motion
        </div>
      </div>
    </div>
  );
}
